export default {
    AGENDADO: 1,
    REAGENDADO_PELO_PACIENTE: 2,
    REAGENDADO_PELO_MEDICO: 3,
    CANCELADO_PELO_PACIENTE: 4,
    CANCELADO_PELO_MEDICO: 5,
    FALTA_DO_PACIENTE: 6,
    FALTA_DO_MEDICO: 7,
    REALIZADO: 8,
}